import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { WALLET } from "@/shared/resource/apis/endpoints";

export const useWalletStore = defineStore("wallet", {
  actions: {
    async getWalletById(walletId) {
      const response = await api.get(WALLET.GET_BY_ID(walletId));
      return response?.data || null;
    },

    async updateWalletBalance(walletId, payload) {
      const response = await api.post(WALLET.POST(walletId), payload);
      return response?.data || null;
    },
  },
});